export const defaultTranslations = {
  dataSharingConsent: "Data Sharing",
  marketing: "Marketing",
  birthDateError: "You must be over the age of 18 to play",
  invalidDate: "Date of birth invalid",
  invalid: "invalid",
  mobilesDontMatch: "Mobile numbers do not match",
  changePhoneValidation: "Phone can only contain numbers and '+' sign",
  changePinValidation: "Pin can only contain numbers",
  changePinDontMatch: "Pin codes do not match",
  confirmPhoneCodeSent: "Code has been sent",
  signUpError: "Sorry, we are unable to complete your registration at this time",
  firstName: "First name",
  firstNameMessage: "This should be exactly as it appears on your ID documents",
  lastName: "Last name",
  state: "State / Province / Region",
  email: "Email",
  emailConfirm: "Confirm email",
  detailsCorrectWarning: "In order to redeem prizes, your details must be correct.",
  mobileVerificationMessage: "We use your mobile number to verify your account.",
  incorrectEmail: "Please enter a valid email address",
  existsEmail: "Email already registered",
  mustBeAtLeast: "must be at least",
  mustBeAtMost: "must be at most",
  unmatchEmail: "Emails don't match",
  existsUserName: "Username already taken",
  postcode: "Postcode",
  postcodeIncorrect: "Postcode must be between 5 and 7 characters",
  postcodeDoesntExist: "Postcode not found.",
  street1: "Street",
  city: "City",
  password: "Password",
  unmatchPasswords: "Passwords don't match",
  incorrectPasswords: "Must be at least 8 characters and contain 1 uppercase character, 1 lowercase character and 1 number",
  edit: "Edit Details",
  birthDate: "Date of birth",
  mobileNumber: "Mobile number",
  mobileNumberConfirm: "Confirm mobile number",
  confirm: "Confirm",
  minLengthError: "must be at least",
  maxLengthError: "must be at most",
  characters: "characters",
  pin: "Pin",
  mustAgreeTerms: "Terms & Conditions must be accepted",
  mustAgreePrivacy: "You must have read and agree to our Privacy Policy",
  username: "Username",
  step: "Step",
  messagePersonalDetails: "Personal details",
  next: "Next",
  back: "Back",
  messageContactDetails: "Contact details",
  signupConfirmation: "Sign Up Confirmation",
  signupConfirmationMessage: "Please confirm the following:",
  signUpMobileWarning: "Please enter your mobile number without a leading zero and your countries international dialing code. For example",
  messageSecurityDetails: "Account Information",
  step4Subtitle: "And finally your consent",
  messageConsentPart1: "You can opt out of promotional messages at any time from your account settings or by contacting us at",
  messageConsentPart2: " To learn more about how we use your personal information and your rights, see our privacy notice at ",
  termsConditions: "Terms and Conditions",
  confirmTermsConditions: "Please confirm that you have read and agreed to our Terms & Conditions",
  privacyCookies: "Privacy & Cookies",
  confirmPrivacyPolicy: "Please confirm that you have read and agreed to our privacy policy",
  confirmMarketing: "If you are happy to receive these messages, please opt-in to your preferred method of contact below:",
  insentiveMarketing: "We would like to contact you about exclusive offers, promotions, contests and bonuses from UltimateFan, Low6 and promotions and offers from our commercial partners. If you agree, we will use your personal information to identify the products and services which we think will be of interest to you.",
  confirmAgreeAll: "By selecting all you agree to the above terms and conditions, Privacy notice and confirm consent for the above marketing mediums.",
  messageTermsPrivacy: "You must agree that you have read terms & conditions and privacy policy to continue.",
  finish: "Finish",
  enterAddress: "Start typing your ZIP Code",
  enterAddressRequired: "A valid Address",
  agreedSmsCommunications: "Yes! I would like to receive SMS communications to my cell phone placed via an autodialer from (or on behalf of) [Legal Tenant]. ",
  smsCommunications: "SMS Communications",
  unableToFindAddress: "Unable to find your address, please try again",
  preferences: "Preferences",
  gameRules: "Game Rules",
  zipCode: "Zip code",
  affiliateLabel: "Yes, I would like to receive additional information and special offers from",
  termsAndPrivacy: "Terms & Privacy",
  byJoiningMessage: "By joining, I confirm that:",
  over18Message: "I am 18 years of age or over",
  emailNotificationsAccepted: "Yes, I want to receive email communications from $1 and its selected partners.",
  iAgree: "I agree to the",
  generalTerms: "General Terms",
  and: "and",
  privacyPolicy: "Privacy Policy",
  privacyPolicyMessage: "I am happy for my personal information to be processed in accordance with the",
  joinNow: "Join Now",
  hasTotoAccountCheckbox: "Yes, I already have an existing Toto account"
};